import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb1bfea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-grid"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-plus me-2" }, null, -1))
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = {
  key: 0,
  class: "card-action float-end"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
  /*#__PURE__*/_createTextVNode("รายงานผล ")
], -1))
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่รายงานผล:")
], -1))
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารแนบ:")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_22 = { class: "text-muted mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmergencyAnswerAttachmentOffcanvasComponent = _resolveComponent("EmergencyAnswerAttachmentOffcanvasComponent")!
  const _component_EmergencyAnswerFormComponent = _resolveComponent("EmergencyAnswerFormComponent")!
  const _component_EmergencyAnswerAttachmentModalComponent = _resolveComponent("EmergencyAnswerAttachmentModalComponent")!
  const _component_EmergencyAnswerAttachmentFormComponent = _resolveComponent("EmergencyAnswerAttachmentFormComponent")!
  const _component_EmergencyAnswerImageModalComponent = _resolveComponent("EmergencyAnswerImageModalComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.emergencyAnswers.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "btn btn-primary mt-3",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.answerClick && _ctx.answerClick(...args)))
          }, [
            _hoisted_2,
            _createTextVNode("รายงานผล ")
          ])
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.emergencyAnswers, (answer, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "card mt-3"
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.isOrs || _ctx.isProvince)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("ul", _hoisted_6, [
                      (_ctx.isOrs || _ctx.isProvince)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
                            }, [
                              _hoisted_8,
                              _createTextVNode("แก้ไขข้อมูล ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOrs || _ctx.isProvince)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.attachmentClick && _ctx.attachmentClick(...args)))
                            }, [
                              _hoisted_10,
                              _createTextVNode("จัดการเอกสารแนบ ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOrs || _ctx.isProvince)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
                            }, [
                              _hoisted_12,
                              _createTextVNode("จัดการรูปภาพประกอบ ")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("p", _hoisted_18, _toDisplayString(answer?.answerDate ? _ctx.thaiDate(answer?.answerDate) : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAttachment && _ctx.showAttachment(...args)), ["stop","prevent"]))
                    }, " ดูเอกสารแนบ ")
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _withDirectives(_createElementVNode("p", _hoisted_22, null, 512), [
                  [_directive_dompurify_html, answer?.description ? answer?.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-']
                ])
              ])
            ])
          ]))
        }), 128)),
    _createVNode(_component_EmergencyAnswerAttachmentOffcanvasComponent, {
      ref: "emergencyAnswerAttachmentOffcanvas",
      "emergency-answer-id": _ctx.emergencyAnswerId
    }, null, 8, ["emergency-answer-id"]),
    _createVNode(_component_EmergencyAnswerFormComponent, {
      ref: "emergencyAnswerForm",
      "emergency-id": _ctx.emergency?.id,
      "emergency-answer-id": _ctx.emergencyAnswerId
    }, null, 8, ["emergency-id", "emergency-answer-id"]),
    _createVNode(_component_EmergencyAnswerAttachmentModalComponent, {
      ref: "emergencyAnswerAttachmentModel",
      "emergency-id": _ctx.emergency?.id,
      "emergency-answer-id": _ctx.emergencyAnswerId,
      onUpload: _ctx.uploadClick
    }, null, 8, ["emergency-id", "emergency-answer-id", "onUpload"]),
    _createVNode(_component_EmergencyAnswerAttachmentFormComponent, {
      ref: "emergencyAnswerAttachmentForm",
      "emergency-id": _ctx.emergency?.id,
      "emergency-answer-id": _ctx.emergencyAnswerId,
      onHidden: _ctx.uploadClose
    }, null, 8, ["emergency-id", "emergency-answer-id", "onHidden"]),
    _createVNode(_component_EmergencyAnswerImageModalComponent, {
      ref: "emergencyAnswerImageModal",
      "emergency-id": _ctx.emergency?.id,
      "emergency-answer-id": _ctx.emergencyAnswerId
    }, null, 8, ["emergency-id", "emergency-answer-id"])
  ], 64))
}